export default __webpack_public_path__ + "static/media/correct13.4c90c93a.mp3";